<app-profile-header
  [profile]="user.company_profile"
  [editDisabled]="somethingIsBeingEdited()"
  [containProfileImage]="true"
>
</app-profile-header>

<div class="about-cube">
  <div class="aboutme-content" fxLayout="column" fxLayoutGap="20px">
    <!-- NAVIGATION -->
    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="10px">
      <ng-container *ngFor="let tabKey of tabKeys; let i = index">
        <ng-container *ngIf="!tabs[tabKey].hidden">
          <button [class.light-grey-button]="tabs[tabKey].selected" (click)="clickNavItem(tabKey)">
            {{ tabs[tabKey].name }}
          </button>
        </ng-container>
      </ng-container>
    </div>

    <div>So sieht dein Profil für andere aus:</div>

    <div>
      <button (click)="preview()">
        <i class="fas fa-globe"></i>
        Ansehen
      </button>
    </div>

    <!-- information blocks -->
    <form [formGroup]="form">
      <!-- info tab -->
      <div *ngIf="tabs['info'].selected" fxLayout="column" fxLayoutGap="30px">
        <!-- Company Information -->
        <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
          <app-about-block-header
            [(edit)]="tabs['info'].edit"
            [title]="'Info'"
            [atts]="tabs['info'].attributes"
            [save]="save.bind(this)"
            [savedisabled]="form.invalid"
            [cancel]="cancel.bind(this)"
            [tooltip]="messages.texts.businessprofile.blockheader.infotexts.companyinformation"
            [(submitted)]="submitted"
            [form]="form"
            [switchTab]="switchTab"
          >
          </app-about-block-header>

          <!-- branche -->
          <div fxLayout="row" fxLayout.lt-lg="column">
            <div fxFlex="22" class="label">Branche:</div>

            <div *ngIf="user.company_profile.type == 'OTHER'">{{ user.company_profile.type_sector | translate }}</div>
            <div *ngIf="user.company_profile.type == 'CARPENTER'">Zimmerer</div>
            <div *ngIf="user.company_profile.type == 'CARPENTER_PLUS'">Zimmerer</div>
          </div>

          <!-- products / services -->
          <div fxLayout="row" fxLayout.lt-lg="column">
            <div fxFlex="22" class="label">Produkte/Services:</div>

            <div [style.display]="tabs['info'].edit ? 'flex' : 'none'" fxFlex="grow">
              <mat-form-field style="width: 100%">
                <input style="width: 100%" type="text" matInput formControlName="information_products" />
              </mat-form-field>
            </div>

            <div [style.display]="tabs['info'].edit ? 'none' : 'flex'">
              {{ user.company_profile.information_products }}
            </div>
          </div>

          <!-- founding year -->
          <div fxLayout="row" fxLayout.lt-lg="column">
            <div fxFlex="22" class="label">Gründungsjahr:</div>

            <div [style.display]="tabs['info'].edit ? 'flex' : 'none'">
              <mat-form-field>
                <input type="number" matInput formControlName="information_year_of_founding" />
              </mat-form-field>
            </div>

            <div [style.display]="tabs['info'].edit ? 'none' : 'flex'">
              {{ user.company_profile.information_year_of_founding }}
            </div>
          </div>
        </div>

        <!-- information_about_us -->
        <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
          <app-about-block-header
            [title]="'Über uns'"
            [tooltip]="messages.texts.businessprofile.blockheader.infotexts.description"
            [(submitted)]="submitted"
            [form]="form"
            [switchTab]="switchTab"
          >
          </app-about-block-header>

          <div>
            <mat-form-field style="width: 100%" [style.display]="tabs['info'].edit ? 'block' : 'none'">
              <textarea
                style="min-height: 100px; width: 100%; padding: 10px 10px; text-indent: 0px; box-sizing: border-box"
                class="zimTextarea"
                matInput
                formControlName="information_about_us"
                autoresize
              ></textarea>
            </mat-form-field>

            <div [style.display]="tabs['info'].edit ? 'none' : 'block'" class="multi_line_text">
              {{ user.company_profile.information_about_us }}
            </div>
          </div>
        </div>

        <!-- information_news -->
        <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
          <app-about-block-header
            [title]="'Aktuelles'"
            [tooltip]="messages.texts.businessprofile.blockheader.infotexts.current"
            [(submitted)]="submitted"
            [form]="form"
            [switchTab]="switchTab"
          >
          </app-about-block-header>

          <div>
            <mat-form-field style="width: 100%" [style.display]="tabs['info'].edit ? 'block' : 'none'">
              <textarea
                style="min-height: 100px; width: 100%; padding: 10px 10px; text-indent: 0px; box-sizing: border-box"
                class="zimTextarea"
                matInput
                formControlName="information_news"
                autoresize
              ></textarea>
            </mat-form-field>

            <div [style.display]="tabs['info'].edit ? 'none' : 'block'" class="multi_line_text">
              {{ user.company_profile.information_news }}
            </div>
          </div>
        </div>
      </div>

      <!-- TODO move tabs to reuseable component / use in company-profile-external as well -->
      <!-- posts tab -->
      <div *ngIf="tabs['posts'].selected && companyProfile.posts" fxLayout="column" fxLayoutGap="30px">
        <div class="posts-container">
          <ng-container *ngFor="let post of companyProfile.posts" [ngSwitch]="post.type">
            <ng-container *ngSwitchCase="'blog'">
              <blog-card [entity]="$any(post).data" data-entitytype="Blog" data-id="{{ post.data.id }}"></blog-card>
            </ng-container>

            <ng-container *ngSwitchCase="'advert'">
              <advert-grid-item
                [entity]="$any(post).data"
                data-entitytype="Advert"
                data-id="{{ post.data.id }}"
              ></advert-grid-item>
            </ng-container>

            <ng-container *ngSwitchCase="'job'">
              <job-card [entity]="$any(post).data" data-entitytype="Job" data-id="{{ post.data.id }}"></job-card>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <!-- references tab -->
      <div *ngIf="tabs['references'].selected" fxLayout="column" fxLayoutGap="30px">
        <!-- products / description - text -->
        <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
          <app-about-block-header
            [(edit)]="tabs['references'].edit"
            [title]="'Produkte / Servicebeschreibung'"
            [atts]="tabs['references'].attributes"
            [save]="save.bind(this)"
            [savedisabled]="form.invalid"
            [cancel]="cancel.bind(this)"
            [tooltip]="messages.texts.businessprofile.blockheader.infotexts.products"
            [(submitted)]="submitted"
            [form]="form"
            [switchTab]="switchTab"
          >
          </app-about-block-header>

          <div fxLayout="row">
            <editor
              [style.display]="tabs['references'].edit ? 'block' : 'none'"
              style="width: 100%"
              apiKey="cirw0hv94c52sgyqp5rseuz1djp09a8nptls2c9a41ypi805"
              [init]="tinyDefaultConfig"
              [formControlName]="'service_products'"
            ></editor>

            <div
              [style.display]="tabs['references'].edit ? 'none' : 'block'"
              [innerHTML]="user.company_profile.service_products"
            ></div>
          </div>
        </div>

        <!-- products / references - images -->
        <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
          <app-about-block-header
            [title]="'Produkte / Referenzen'"
            [tooltip]="messages.texts.businessprofile.blockheader.infotexts.references"
            [(submitted)]="submitted"
            [form]="form"
            [switchTab]="switchTab"
          >
          </app-about-block-header>

          <div fxLayout="column" fxLayoutGap="15px">
            <div *ngIf="!tabs['references'].edit; else referenceImagesElse">
              <edit-images
                [images]="user.company_profile.productImages"
                [deleteImage]="deleteImage.bind(this)"
                [key]="'COMPANY_PRODUCT'"
              ></edit-images>

              <image-upload-box
                [fileSelected]="fileSelected.bind(this)"
                [fileDropped]="fileDropped.bind(this)"
                [key]="'COMPANY_PRODUCT'"
              >
              </image-upload-box>
            </div>
            <ng-template #referenceImagesElse>
              Bitte schließe erst den Text Bearbeitungsvorgang ab bevor du hier Bilder hochladen kannst.
            </ng-template>
          </div>
        </div>

        <!-- certificates / team - images -->
        <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
          <app-about-block-header
            [title]="'Unternehmen / Team'"
            [tooltip]="messages.texts.businessprofile.blockheader.infotexts.certificates"
            [(submitted)]="submitted"
            [form]="form"
            [switchTab]="switchTab"
          >
          </app-about-block-header>

          <div fxLayout="column" fxLayoutGap="15px">
            <div *ngIf="!tabs['references'].edit; else teamImagesElse">
              <edit-images
                [images]="user.company_profile.certifacteImages"
                [deleteImage]="deleteImage.bind(this)"
                [key]="'COMPANY_CERTIFICATE'"
              ></edit-images>

              <image-upload-box
                [fileSelected]="fileSelected.bind(this)"
                [fileDropped]="fileDropped.bind(this)"
                [key]="'COMPANY_CERTIFICATE'"
              >
              </image-upload-box>
            </div>
            <ng-template #teamImagesElse>
              Bitte schließe erst den Text Bearbeitungsvorgang ab bevor du hier Bilder hochladen kannst.
            </ng-template>
          </div>
        </div>
      </div>

      <!-- contactpersons tab -->
      <div *ngIf="tabs['contactpersons'].selected" fxLayout="column" fxLayoutGap="30px">
        <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
          <app-about-block-header
            [(edit)]="tabs['contactpersons'].edit"
            [title]="'Ansprechpartner'"
            [atts]="tabs['contactpersons'].attributes"
            [save]="saveContactpersons.bind(this)"
            [savedisabled]="form.invalid"
            [cancel]="cancel.bind(this)"
            [tooltip]="messages.texts.businessprofile.blockheader.infotexts.contactpersons"
            [(submitted)]="submitted"
            [form]="form"
            [switchTab]="switchTab"
          >
          </app-about-block-header>

          <!-- edit contactpersons -->
          <div *ngIf="tabs['contactpersons'].edit" fxLayout="column" fxLayoutGap="10px">
            <div formArrayName="contactpersons" *ngFor="let c of form.get('contactpersons')['controls']; let i = index">
              <div [formGroupName]="i" fxLayout="column" fxLayoutGap="10px">
                <div fxLayout="row" fxLayout.lt-lg="column">
                  <div fxFlex="20" class="label">Bereich / Region:</div>
                  <div class="full-width-input">
                    <mat-form-field>
                      <input type="text" matInput formControlName="area" />
                    </mat-form-field>
                  </div>
                </div>

                <div fxLayout="row" fxLayout.lt-lg="column">
                  <div fxFlex="20" class="label">Vorname:</div>
                  <div class="full-width-input">
                    <mat-form-field>
                      <input type="text" matInput formControlName="firstname" />
                    </mat-form-field>
                  </div>
                </div>

                <div fxLayout="row" fxLayout.lt-lg="column">
                  <div fxFlex="20" class="label">Nachname:</div>
                  <div class="full-width-input">
                    <mat-form-field>
                      <input type="text" matInput formControlName="lastname" />
                    </mat-form-field>
                  </div>
                </div>

                <div fxLayout="row" fxLayout.lt-lg="column">
                  <div fxFlex="20" class="label">Telefon:</div>
                  <div class="full-width-input">
                    <mat-form-field>
                      <input type="text" matInput formControlName="tel" />
                    </mat-form-field>

                    <mat-error
                      *ngIf="
                        form.get('contactpersons')['controls'][i].get('tel').errors &&
                        (submitted || form.get('contactpersons')['controls'][i].get('tel').touched)
                      "
                    >
                      {{ messages.telInvalid }}
                    </mat-error>
                  </div>
                </div>

                <div fxLayout="row" fxLayout.lt-lg="column">
                  <div fxFlex="20" class="label">E-Mail:</div>
                  <div class="full-width-input">
                    <mat-form-field>
                      <input type="text" matInput formControlName="email" />
                    </mat-form-field>

                    <mat-error
                      *ngIf="
                        form.get('contactpersons')['controls'][i].get('email').errors &&
                        (submitted || form.get('contactpersons')['controls'][i].get('email').touched)
                      "
                    >
                      {{ messages.emailInvalid }}
                    </mat-error>
                  </div>
                </div>

                <!-- delete button -->
                <div fxLayout="row" fxLayoutAlign="center center">
                  <button
                    *ngIf="tabs['contactpersons'].edit"
                    type="button"
                    (click)="removeContactPerson(i)"
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="10px"
                    class="red-button"
                  >
                    <i class="fas fa-trash"></i>
                    <div>Ansprechpartner löschen</div>
                  </button>
                </div>

                <!-- line -->
                <div style="border-bottom: 1px solid black"></div>
              </div>
            </div>
          </div>

          <!-- add button -->
          <div
            *ngIf="tabs['contactpersons'].edit"
            style="margin-top: 10px"
            fxLayout="row"
            fxLayoutAlign="center center"
          >
            <button
              type="button"
              (click)="addContactPerson()"
              fxLayout="row"
              fxLayoutGap="10px"
              fxLayoutAlign="start center"
              class="orange-button"
            >
              <i class="fas fa-plus"></i>
              <div>Ansprechpartner hinzufügen</div>
            </button>
          </div>

          <!-- show contactpersons -->
          <div *ngIf="!tabs['contactpersons'].edit" fxLayout="column" fxLayoutGap="20px">
            <div *ngFor="let c of user.company_profile.contactpersons" fxLayout="column" fxLayoutGap="10px">
              <div fxLayout="row" fxLayout.lt-lg="column">
                <div fxFlex="20" class="label">Bereich:</div>
                <div>{{ c.area }}</div>
              </div>

              <div fxLayout="row" fxLayout.lt-lg="column">
                <div fxFlex="20" class="label">Vorname:</div>
                <div>{{ c.firstname }}</div>
              </div>

              <div fxLayout="row" fxLayout.lt-lg="column">
                <div fxFlex="20" class="label">Nachname:</div>
                <div>{{ c.lastname }}</div>
              </div>

              <div fxLayout="row" fxLayout.lt-lg="column">
                <div fxFlex="20" class="label">Telefon:</div>
                <div>{{ c.tel }}</div>
              </div>

              <div fxLayout="row" fxLayout.lt-lg="column">
                <div fxFlex="20" class="label">E-Mail:</div>
                <div style="word-break: break-all">{{ c.email }}</div>
              </div>

              <!-- line -->
              <div fxFlex="grow" style="border-top: 1px solid lightgray"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- contact tab -->
      <div [fxHide]="!tabs['contact'].selected" fxLayout="column" fxLayoutGap="30px">
        <!-- contact -->
        <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
          <app-about-block-header
            [(edit)]="tabs['contact'].edit"
            [title]="'Kontakt'"
            [atts]="tabs['contact'].attributes"
            [save]="save.bind(this)"
            [savedisabled]="form.invalid"
            [cancel]="cancel.bind(this)"
            [(submitted)]="submitted"
            [form]="form"
            [switchTab]="switchTab"
          >
          </app-about-block-header>

          <!-- contact name -->
          <div fxLayout="row" fxLayout.lt-lg="column">
            <div fxFlex="20" class="label">Ansprechpartner:</div>

            <div [style.display]="tabs['contact'].edit ? 'flex' : 'none'" fxFlex="grow">
              <div class="full-width-input">
                <mat-form-field>
                  <input type="text" matInput formControlName="contact_name" />
                </mat-form-field>
              </div>
            </div>

            <div [style.display]="tabs['contact'].edit ? 'none' : 'flex'">
              {{ user.company_profile.contact_name }}
            </div>
          </div>

          <!-- contact position -->
          <div fxLayout="row" fxLayout.lt-lg="column">
            <div fxFlex="20" class="label">Position:</div>

            <div [style.display]="tabs['contact'].edit ? 'flex' : 'none'" fxFlex="grow">
              <div class="full-width-input">
                <mat-form-field>
                  <input type="text" matInput formControlName="contact_position" />
                </mat-form-field>
              </div>
            </div>

            <div [style.display]="tabs['contact'].edit ? 'none' : 'flex'">
              {{ user.company_profile.contact_position }}
            </div>
          </div>

          <!-- phone -->
          <div fxLayout="row" fxLayout.lt-lg="column">
            <div fxFlex="20" class="label">Telefon:</div>

            <div [style.display]="tabs['contact'].edit ? 'flex' : 'none'" fxFlex="grow">
              <div class="full-width-input">
                <mat-form-field>
                  <input type="text" matInput formControlName="telephone" />
                </mat-form-field>

                <mat-error *ngIf="form.get('telephone').errors && (submitted || form.get('telephone').touched)">
                  {{ messages.telInvalid }}
                </mat-error>
              </div>
            </div>

            <div [style.display]="tabs['contact'].edit ? 'none' : 'flex'">
              {{ user.company_profile.telephone }}
            </div>
          </div>

          <!-- email -->
          <div fxLayout="row" fxLayout.lt-lg="column">
            <div fxFlex="20" class="label">E-Mail:</div>

            <div [style.display]="tabs['contact'].edit ? 'flex' : 'none'" fxFlex="grow">
              <div class="full-width-input">
                <mat-form-field>
                  <input type="text" matInput formControlName="email" />
                </mat-form-field>

                <mat-error *ngIf="form.get('email').errors && (submitted || form.get('email').touched)">
                  {{ messages.emailInvalid }}
                </mat-error>
              </div>
            </div>

            <div [style.display]="tabs['contact'].edit ? 'none' : 'flex'" class="label">
              <a [href]="'mailto:' + user.company_profile.email">{{ user.company_profile.email }}</a>
            </div>
          </div>

          <!-- website -->
          <div fxLayout="row" fxLayout.lt-lg="column">
            <div fxFlex="20" class="label">Webseite:</div>

            <!-- edit -->
            <div [style.display]="tabs['contact'].edit ? 'flex' : 'none'" fxFlex="grow">
              <div class="full-width-input">
                <mat-form-field>
                  <input type="text" matInput formControlName="website" />
                </mat-form-field>
              </div>
            </div>

            <!-- show -->
            <div [style.display]="tabs['contact'].edit ? 'none' : 'flex'" class="label" style="word-break: break-all">
              <a [href]="user.company_profile.website" target="_blank">
                {{ user.company_profile.website }}
              </a>
            </div>
          </div>
        </div>

        <!-- address -->
        <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
          <app-about-block-header [title]="'Unternehmensadresse'" [switchTab]="switchTab"> </app-about-block-header>

          <!-- address show -->
          <div [style.display]="!tabs['contact'].edit ? 'block' : 'none'">
            <div fxLayout="row">
              <!-- info -->
              <div fxFlex="50">
                <div>{{ user.company_profile.name }}</div>
                <div>{{ user.company_profile.street }} {{ user.company_profile.street_additional }}</div>
                <div>{{ user.company_profile.zip }} {{ user.company_profile.city }}</div>
                <div>{{ user.company_profile.state }}</div>
                <div>{{ user.company_profile.country }}</div>
                <div *ngIf="user.company_profile.impressum">
                  <a
                    [href]="user.company_profile.impressum"
                    target="_blank"
                    style="color: black; text-decoration: underline"
                    >Impressum</a
                  >
                </div>
              </div>

              <!-- google map -->
              <!-- <div fxFlex="50" style="padding: 10px 0;">
                <app-zim-gmap [profile]="userService.user.company_profile"></app-zim-gmap>
              </div> -->
            </div>
          </div>

          <!-- address edit -->
          <div [style.display]="tabs['contact'].edit ? 'block' : 'none'">
            <!-- name -->
            <div fxLayout="row" fxLayout.lt-lg="column">
              <div fxFlex="15" class="label">Name:</div>
              <div class="full-width-input">
                <mat-form-field>
                  <input type="text" matInput formControlName="name" />
                </mat-form-field>
                <mat-error *ngIf="form.get('name').errors && (submitted || form.get('name').touched)">
                  {{ messages.companyNameInvalid }}
                </mat-error>
              </div>
            </div>

            <!-- str, number -->
            <div fxLayout="row" fxLayout.lt-lg="column">
              <div fxFlex="15" class="label">Str./Nummer:</div>
              <mat-form-field style="margin-right: 10px">
                <input type="text" matInput formControlName="street" />
              </mat-form-field>
              <mat-form-field>
                <input type="text" matInput formControlName="street_additional" />
              </mat-form-field>
            </div>

            <!-- zip city -->
            <div fxLayout="row" fxLayout.lt-lg="column">
              <div fxFlex="15" class="label">PLZ / Stadt:</div>

              <!-- old @angular-material-extensions/google-maps-autocomplete autocomplete -->
              <!-- <mat-form-field style="margin-right: 10px;">
                <input matInput
                  type="number"
                  formControlName="zip"
                  matGoogleMapsAutocomplete
                  [types]="['geocode']"
                  [country]="['de','at','ch']"
                  (onAutocompleteSelected)="onAutocompleteSelected($event)">
              </mat-form-field> -->

              <!-- FIELDs WITHOUT GOOGLE COMPLETION -->
              <mat-form-field>
                <input matInput type="text" formControlName="zip" placeholder="PLZ" />
              </mat-form-field>

              <mat-form-field>
                <input matInput formControlName="city" />
              </mat-form-field>
            </div>

            <!-- state -->
            <div fxLayout="row" fxLayout.lt-lg="column">
              <div fxFlex="15" class="label">Bundesland:</div>
              <div class="full-width-input">
                <mat-form-field>
                  <input type="text" matInput formControlName="state" />
                </mat-form-field>
              </div>
            </div>

            <!-- country -->
            <div fxLayout="row" fxLayout.lt-lg="column">
              <div fxFlex="15" class="label">Land:</div>
              <div>
                <mat-form-field>
                  <mat-select formControlName="country">
                    <mat-option *ngFor="let c of countries" [value]="c">{{ c }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <!-- impressum -->
            <div fxLayout="row" fxLayout.lt-lg="column">
              <div fxFlex="15" class="label">Link zum Impressum:</div>
              <div class="full-width-input">
                <mat-form-field>
                  <input type="text" matInput formControlName="impressum" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <!-- opening hours -->
        <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
          <app-about-block-header [title]="'Öffnungszeiten'" [switchTab]="switchTab"> </app-about-block-header>

          <mat-form-field style="width: 100%" [style.display]="tabs['contact'].edit ? 'block' : 'none'">
            <textarea
              style="
                min-height: 100px;
                width: 100%;
                height: 115px;
                padding: 10px 10px;
                text-indent: 0px;
                box-sizing: border-box;
              "
              class="zimTextarea"
              matInput
              formControlName="information_opening_hours"
              autoresize
            ></textarea>
          </mat-form-field>

          <div [style.display]="tabs['contact'].edit ? 'none' : 'block'" style="white-space: pre-line">
            {{ user.company_profile.information_opening_hours }}
          </div>
        </div>
      </div>

      <!-- socialmedia tab -->
      <div *ngIf="tabs['socialmedia'].selected" fxLayout="column" fxLayoutGap="30px">
        <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
          <app-about-block-header
            [(edit)]="tabs['socialmedia'].edit"
            [title]="'Socialmedia'"
            [atts]="tabs['socialmedia'].attributes"
            [save]="save.bind(this)"
            [savedisabled]="form.invalid"
            [cancel]="cancel.bind(this)"
            [tooltip]="messages.texts.businessprofile.blockheader.infotexts.socialmedia"
            [(submitted)]="submitted"
            [form]="form"
            [switchTab]="switchTab"
          >
          </app-about-block-header>

          <!-- edit -->
          <div [style.display]="tabs['socialmedia'].edit ? 'block' : 'none'">
            <!-- facebook -->
            <div fxLayout="column" fxLayout.gt-md="row">
              <div fxFlex="15" class="label">Facebook:</div>
              <mat-form-field fxFlex="grow">
                <input type="text" matInput formControlName="facebook" />
              </mat-form-field>
            </div>

            <!-- instagram -->
            <div fxLayout="column" fxLayout.gt-md="row">
              <div fxFlex="15" class="label">Instagram:</div>
              <mat-form-field fxFlex="grow">
                <input type="text" matInput formControlName="instagram" />
              </mat-form-field>
            </div>

            <!-- LinkedIn -->
            <div fxLayout="column" fxLayout.gt-md="row">
              <div fxFlex="15" class="label">LinkedIn:</div>
              <mat-form-field fxFlex="grow">
                <input type="text" matInput formControlName="linkedin" />
              </mat-form-field>
            </div>

            <!-- xing -->
            <div fxLayout="column" fxLayout.gt-md="row">
              <div fxFlex="15" class="label">Xing:</div>
              <mat-form-field fxFlex="grow">
                <input type="text" matInput formControlName="xing" />
              </mat-form-field>
            </div>

            <!-- youtube -->
            <div fxLayout="column" fxLayout.gt-md="row">
              <div fxFlex="15" class="label">Youtube:</div>
              <mat-form-field fxFlex="grow">
                <input type="text" matInput formControlName="youtube" />
              </mat-form-field>
            </div>

            <!-- twitter -->
            <div fxLayout="column" fxLayout.gt-md="row">
              <div fxFlex="15" class="label">Twitter:</div>
              <mat-form-field fxFlex="grow">
                <input type="text" matInput formControlName="twitter" />
              </mat-form-field>
            </div>
          </div>

          <!-- show -->
          <div [style.display]="!tabs['socialmedia'].edit ? 'block' : 'none'" fxLayout="column" fxLayoutGap="5px">
            <ng-container *ngFor="let key of socialmediakeys">
              <a
                class="socialmediarow"
                [href]="form.get(key).value"
                target="_blank"
                *ngIf="user.company_profile[key]"
                fxLayout="column"
                fxLayout.gt-xs="row"
                fxLayoutGap="10px"
                style="padding-left: 10px"
              >
                <div fxLayout="row" fxLayoutGap="15px">
                  <i style="font-size: 40px" [class]="socialmedia[key].icon"></i>
                  <div fxLayout="row" fxLayoutAlign="start center">Finde uns auf {{ socialmedia[key].name }}</div>
                </div>
              </a>
            </ng-container>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
